<template>
	<div>
		<div :id="'builder' + id"></div>
	</div>
</template>

<script>
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	import $ from "jquery";
	import alasql from "alasql";
	import * as CSV from "csv-string";
	import uniqueId from "lodash.uniqueid";

	export default {
		name: "queryBuilder",
		data: function () {
			return {
				rules: "",
				rules_sql: "",
				id: uniqueId(""),
			};
		},
		props: {
			columns: {
				default: uniqueId(""),
            },
        },
		watch: {
			columns: {
				deep: true,
				handler: function () {
					var columns = this.columns;

					var columns_query_builder = [];
					for (var i = 0; i < columns.length; i++) {
						columns_query_builder.push({
							id: "`" + columns[i] + "`",
							label: columns[i],
							type: "string",
						});
					}

					$("#builder" + this.id).queryBuilder(
						"setFilters",
						true,
						columns_query_builder
					);
				},
			},
		},
		methods: {
			save() {
				return {
                    rules: this.rules,
                    rules_sql: this.rules_sql
				};
			},
			async load(data) {
				if (data.rules)
				{
					try {
						$("#builder" + this.id).queryBuilder(
							"setRules",
							data.rules
						);
					} catch (err) {
					}
				}
			},
			setBuilder() {
				var self = this;
                var id = this.id;
                
                var columns = this.columns;

				var columns_query_builder = [];
				for (var i = 0; i < columns.length; i++) {
					columns_query_builder.push({
						id: "`" + columns[i] + "`",
						label: columns[i],
						type: "string",
					});
				}

				var config = {
					filters: columns_query_builder,
					icons: {
						add_group: "fas fa-plus-square",
						add_rule: "fas fa-plus-circle",
						remove_group: "fas fa-minus-square",
						remove_rule: "fas fa-minus-circle",
						error: "fas fa-exclamation-triangle",
					},
					operators: [
						{ type: "equal" },
						{ type: "not_equal" },
						{ type: "less" },
						{ type: "less_or_equal" },
						{ type: "greater" },
						{ type: "greater_or_equal" },
						{ type: "between" },
						{ type: "contains" },
						{ type: "not_contains" },
						{ type: "begins_with" },
						{ type: "ends_with" },
						{
							type: "is_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
						{
							type: "is_not_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
					],
				};

				$("#builder" + id).queryBuilder(config);

				$("#builder" + id).on(
					"change",
					function (e, rule, error, value) {
						try {
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = " " + self.rules_sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							self.rules = $("#builder" + id).queryBuilder(
								"getRules"
							);
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteRule.queryBuilder",
					function (e, rule, error, value) {
						try {
							//self.rules = $('#builder').queryBuilder('getRules');
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = " " + self.rules_sql;
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteGroup.queryBuilder",
					function (e, group) {
						try {
							self.rules_sql = " " + $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);
			},
        },
        async mounted() {
            this.setBuilder();
        }
    }
</script>